module.exports = __webpack_public_path__ + "static/media/maxigo-difficulty-baby.0d36f43c.png";